import cashBookInstance from '../cashBook/instance'

const getAllCashBooks = (page = 0, size = 0, dateFrom, dateTo) => {
	return cashBookInstance.get('/cash-book/records' + ((page || size) ? '?page=' + page + '&size=' + size : '')
		+ (dateFrom ? '&dateFrom=' + dateFrom : '')
		+ (dateTo ? '&dateTo=' + dateTo : ''))
}

export default getAllCashBooks

